import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Section0 = () => {
  return (
    <section className="flex relative flex-col flex-1 w-full h-fit sm:text-center justify-center items-center px-4 py-5 sm:pt-10">
      {" "}
      <h1 className="text-3xl sm:text-4xl mt-5 sm:mt-0 font-bold  leading-wider">
        Engage Website Visitors,
        <br />
        Drive Conversions With a Data-Driven AI
        <br />
        Chatbot Customized For Your Website
      </h1>
      <h2 className="text-sm sm:text-2xl 2xl:text-4xl font-semibold mt-8 sm:mt-2 ml-2 sm:ml-0">
        Jaano Chatbot instantly helps your customers using AI-generated
        responses. <br />
        Get 24/7 support and easily embed into your Website.
      </h2>
      <motion.div
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        className="mt-3 flex w-full flex-col x sm:flex-row gap-3 ">
        <Link
          onClick={() => {
            localStorage.setItem("renderCountPlan", JSON.stringify(1));
            localStorage.setItem("selectedCurrency", "USD");
          }}
          to={true ? "/signup" : "/login"}
          className="w-full">
          <div className="relative inline-block 2xl:text-2xl">
            <div className="absolute bottom-2.5 h-4 w-full translate-y-full rounded-b-lg bg-gradient-to-r from-[#FB923C] via-[#F472B6] to-[#E879F9]"></div>
            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors relative h-fit w-full sm:w-fit rounded-xl py-3 px-5 before:bg-gradient-to-r before:from-[#E879F9] before:via-[#F472B6] before:to-[#FB923C] bg-zinc-950 text-white hover:bg-primarydark ">
              Try Jaano Chatbot Free
            </button>
          </div>
        </Link>
        {/* <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors border border-primary border-solide border-2 rounded-xl px-5 py-3 ">
          Get Demo{" "}
        </button> */}
      </motion.div>
    </section>
  );
};

export default Section0;
